module.exports = __webpack_public_path__ + "asset/img/receive-coupons.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/weixinPackImg/receive-coupons.png
// module id = 558
// module chunks = 2 3 8 10 22